import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  return title.includes('torino') || name.includes('torino');
};

const renderTitle = (item, lang) => {
  const suffix = lang.toLowerCase();
  const title = item[`title_${suffix}`] || (suffix === 'it' ? item.title : '');
  const value =
    item[`menu_value_${suffix}`] || (suffix === 'it' ? item.menu_value : '');

  if (item.menu_type === 'link') {
    if (!title && !value) {
      return '—';
    }

    return (
      <a
        href={value || '#'}
        target={item.open_in_new_tab ? '_blank' : undefined}
        rel='noreferrer'
      >
        {title || value}
      </a>
    );
  }

  return display(title);
};

const renderMenuValue = (item, lang) => {
  const suffix = lang.toLowerCase();
  const value =
    item[`menu_value_${suffix}`] || (suffix === 'it' ? item.menu_value : '');

  return display(value);
};

const buildLanguageFields = (t, item, lang) => {
  return [
    { text: `${t('Titolo')} ${lang}`, value: renderTitle(item, lang) },
    {
      text: `${t('Valore')} ${lang}`,
      value: renderMenuValue(item, lang),
    },
  ];
};

export const getFooterMenuViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const menuTypeLabel =
    item.menu_type === 'link' ? t('Link') : t('Testo');

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        {
          text: t('Tipo'),
          value: display(menuTypeLabel),
        },
        ...(item.menu_type === 'link'
          ? [
              {
                text: t('Aprire nella nuova scheda?'),
                value: item.open_in_new_tab ? t('Sì') : t('No'),
              },
            ]
          : []),
      ],
    },
    {
      title: `${t('Contenuto')} (IT)`,
      fields: buildLanguageFields(t, item, 'IT'),
    },
    {
      title: `${t('Contenuto')} (EN)`,
      fields: buildLanguageFields(t, item, 'EN'),
    },
  ];

  if (isTorinoCenter(item)) {
    sections.push({
      title: `${t('Contenuto')} (FR)`,
      fields: buildLanguageFields(t, item, 'FR'),
    });
  }

  return sections;
};
